import { OrderTypes } from "@dana/Handlers/ProductAvailabilityHandler";
import { addAnnualReturnsLineCollection, addEmergencyLineCollection, addLineCollection, addStandardReturnsLineCollection } from "@dana/Overrides/Services/CartService";
import {
    addToChainBefore,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddLinesToCart";
import { getCookie } from "@insite/mobius/utilities/cookies";


// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
addToChainBefore(
    chain,
    PopulateApiParameter,
    props => {

        props.apiParameter = props.parameter.apiParameter;
        const orderType = getCookie('modalOrderType');
        if (orderType === OrderTypes.EMERGENCY) {
            props.apiParameter.additionalQueryStringParameters = {
                "IsEmergencyOrder": true
            }
        }
        if (orderType === OrderTypes.ANNUALRETURNS) {
            props.apiParameter.additionalQueryStringParameters = {
                "IsAnnualReturnsOrder": true
            }
        }
        if (orderType === OrderTypes.STANDARDRETURNS) {
            props.apiParameter.additionalQueryStringParameters = {
                "IsStandardReturnsOrder": true
            }
        }


    },
);
replaceInChain(
    chain,
    RequestDataFromApi,
    async props => {
        const isEmergency =
            props.apiParameter?.additionalQueryStringParameters?.IsEmergencyOrder === true;

        const isAnnualReturns =
            props.apiParameter?.additionalQueryStringParameters?.IsAnnualReturnsOrder === true;

        const isStandardReturns =
            props.apiParameter?.additionalQueryStringParameters?.IsStandardReturnsOrder === true;

        if (isEmergency) {
            props.apiResult = await addEmergencyLineCollection(props.apiParameter);
        }
        else if (isAnnualReturns) {
            props.apiResult = await addAnnualReturnsLineCollection(props.apiParameter);
        }
        else if (isStandardReturns) {
            props.apiResult = await addStandardReturnsLineCollection(props.apiParameter);
        }
        else {
            props.apiResult = await addLineCollection(props.apiParameter);
        }
    }
);